import { Component } from 'react'
import { withTheme } from 'styled-components'

import { createSpacing } from './Utils'

interface WithSpacingProps {
  separator?: boolean
  spacing?: string
  theme?: {
    separator?: object
    spacing?: object
  }
}

export default function withSpacing(WrappedComponent: any) {
  class WithSpacing extends Component<WithSpacingProps> {
    static displayName = `WithSpacing(${getDisplayName(WrappedComponent)})`

    constructor(props: any) {
      super(props)

      this.computedStyles = this.computedStyles.bind(this)
    }

    computedStyles() {
      const { theme, separator, spacing } = this.props
      const spacingStyle = spacing || WrappedComponent.spacing || 'default'

      // @ts-expect-error
      const resultSpacing = theme.spacing[spacingStyle] || 0
      // @ts-expect-error
      const lineThickness = separator ? theme.separator.lineThickness : 0
      // @ts-expect-error
      const lineColor = separator ? theme.separator.lineColor : null

      return createSpacing(theme, WrappedComponent.orientation || 'horizontal', resultSpacing, lineThickness, lineColor)
    }

    render() {
      return (
        <div style={this.computedStyles()} data-item={'wg-spacer'}>
          <WrappedComponent {...this.props} />
        </div>
      )
    }
  }

  return withTheme(WithSpacing)
}

function getDisplayName(WrappedComponent: any) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
